var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSysBusy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24422",
    "data-name": "Group 24422",
    transform: "translate(12970 1067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3617",
    "data-name": "Ellipse 3617",
    transform: "translate(-12970 -1067)",
    fill: "rgba(236,173,0,0.7)",
    stroke: "#ecad00",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "notify3",
    transform: "translate(-12965.739 -1063)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5355",
    "data-name": "Rectangle 5355",
    width: 14,
    height: 14,
    transform: "translate(-0.262 0)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-clock",
    d: "M8.3,2a6.3,6.3,0,1,0,6.3,6.3A6.3,6.3,0,0,0,8.3,2Zm1.629,8.82L7.855,8.745A.629.629,0,0,1,7.67,8.3V5.15a.63.63,0,0,1,.63-.63h0a.63.63,0,0,1,.63.63V8.039l1.89,1.89a.63.63,0,0,1,0,.891h0A.63.63,0,0,1,9.929,10.82Z",
    transform: "translate(-1.562 -1.3)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSysBusy);
export default __webpack_public_path__ + "static/media/sys_busy.d48d7f0f1fa07221fb407e1f75b6614f.svg";
export { ForwardRef as ReactComponent };